import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

function QuestionBox() {
    const [showQuestionBody, setShowQuestionBody] = useState(false);
    const [show, setShow] = useState(false);
    const search = useLocation().search;
    const offerName = new URLSearchParams(search).get("offer");

    let partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const retailerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );
    const partnerEmail: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.email ? state.configurationState.configuration.partnerConfig.email : ""
    );

    if (retailerPhoneNumber.trim() != "") {
        partnerPhoneNumber = retailerPhoneNumber;
    }

    const questionHandler = () => {
        setShowQuestionBody(!showQuestionBody);
        setTimeout(() => setShow(!show), 5);
    }
    return (
        <>
            <div className="questions-box-wrapper">
                <div className="questions-box-container">
                    <div className="questions-box">
                        <div
                            role="button"
                            tabIndex={0}
                            className="questions-header"
                            aria-expanded={showQuestionBody}
                            aria-controls="expanded-section"
                            id="question-box"
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || (event.key === " " || event.key === "Space")) {
                                    questionHandler();
                                }
                            }}
                            onClick={() => {
                                questionHandler();
                                window.addToDataLayer({ event: "dtcSalesLandingQuestionBox" });
                            }}
                        >
                            QUESTIONS? <em id="questions-caret" className={showQuestionBody ? "fa fa-angle-down" : "fa fa-angle-up"}></em>
                        </div>
                        <div id="expanded-section" aria-labelledby="question-box" style={show ? {} : { display: "none" }}>
                            <div className="questions-sections">
                                <span>
                                    <a
                                        href={"tel:" + partnerPhoneNumber.replace(new RegExp("-", "g"), "")}
                                        onClick={() => {
                                            window.addToDataLayer({ event: "dtcClickToCallTFN" });
                                        }}
                                        className="question-links"
                                        style={{ color: "inherit" }}
                                    >
                                        Call {partnerPhoneNumber}
                                    </a>
                                </span>
                            </div>
                            <div className="questions-sections">
                                <span>
                                <a
                                    href={"mailto:" + partnerEmail}
                                    className="btn-default send-email-btn question-links"
                                    onClick={() => {
                                        window.addToDataLayer({ event: "dtcSalesLandingClickSendUsEmail" });
                                    }}
                                 
                                >
                                    Send Us An Email
                                </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default QuestionBox;
